// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Sign/ApproveUser/ApproveUser.css */

.approve-user-container {
    display: flex;
    margin: auto;
}

.approve-user-card {
    background: white;
    padding: 30px;
    width: 100%;
    text-align: center;
}

.approve-user-heading {
    color: #364C63;
    text-align: center;
    font-size: 1.5rem;
    font-weight: bold;
    letter-spacing: 0.05rem;
    margin-bottom: 1rem;
    margin-top: 1rem;
}

.error-messagee {
    background-color: #ffebee;
    color: #c62828;
    padding: 10px;
    border-radius: 4px;
    margin-bottom: 20px;
}

.success-messagee {
    background-color: #e8f5e9;
    color: #2e7d32;
    padding: 10px;
    border-radius: 4px;
    margin-bottom: 20px;
}

.approval-buttons {
    margin-top: 3rem;
}
.approve-user-para{
    color: #364C63;
    text-align: center;
    font-size: 1rem;
    letter-spacing: 0.05rem;
    margin-bottom: 1rem;
    margin-top: 1rem;
}

.button-grouppp {
    display: flex;
    gap: 15px;
    justify-content: center;
    margin-top: 2rem;
}

.approve-button {
    background-color: #EF6F53;
    color: white;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.3s;
    font-size: 0.85rem;
}

.reject-button {
    background-color: #EF6F53;
    color: white;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.3s;
    font-size: 0.85rem;
}



.approve-button:hover {
    background-color: #43a047;
}

.reject-button:hover {
    background-color: #e53935;
}
`, "",{"version":3,"sources":["webpack://./src/components/routes/Sign/ApproveUser/ApproveUser.css"],"names":[],"mappings":"AAAA,2DAA2D;;AAE3D;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;IACjC,kBAAkB;AACtB;;;;AAIA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":["/* src/components/routes/Sign/ApproveUser/ApproveUser.css */\n\n.approve-user-container {\n    display: flex;\n    margin: auto;\n}\n\n.approve-user-card {\n    background: white;\n    padding: 30px;\n    width: 100%;\n    text-align: center;\n}\n\n.approve-user-heading {\n    color: #364C63;\n    text-align: center;\n    font-size: 1.5rem;\n    font-weight: bold;\n    letter-spacing: 0.05rem;\n    margin-bottom: 1rem;\n    margin-top: 1rem;\n}\n\n.error-messagee {\n    background-color: #ffebee;\n    color: #c62828;\n    padding: 10px;\n    border-radius: 4px;\n    margin-bottom: 20px;\n}\n\n.success-messagee {\n    background-color: #e8f5e9;\n    color: #2e7d32;\n    padding: 10px;\n    border-radius: 4px;\n    margin-bottom: 20px;\n}\n\n.approval-buttons {\n    margin-top: 3rem;\n}\n.approve-user-para{\n    color: #364C63;\n    text-align: center;\n    font-size: 1rem;\n    letter-spacing: 0.05rem;\n    margin-bottom: 1rem;\n    margin-top: 1rem;\n}\n\n.button-grouppp {\n    display: flex;\n    gap: 15px;\n    justify-content: center;\n    margin-top: 2rem;\n}\n\n.approve-button {\n    background-color: #EF6F53;\n    color: white;\n    border: none;\n    padding: 0.5rem 1rem;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n    font-size: 0.85rem;\n}\n\n.reject-button {\n    background-color: #EF6F53;\n    color: white;\n    border: none;\n    padding: 0.5rem 1rem;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n    font-size: 0.85rem;\n}\n\n\n\n.approve-button:hover {\n    background-color: #43a047;\n}\n\n.reject-button:hover {\n    background-color: #e53935;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
